import React                   from 'react'
import { connect }             from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import i18n from '../../../i18n';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from '../../forms/DatePicker'
import Formsy from 'formsy-react';
import Input from '../../forms/services/Input';
import CheckBox from '../../forms/services/CheckBox'
import Radio from '../../forms/services/Radio'
import Table from '../../forms/services/Table'
import withBaseComponent from '../../withBaseComponent';
import { parseHtml } from '../../../util/parse-html';
import lodash from "lodash"

class EditLogin extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    let { aggregation_start_date } = this.props.account

    this.state = {
      hasSpecifyDate: aggregation_start_date ? true : false,
      startDate: aggregation_start_date
    }

    this.accountCredential = this.mergedCredentials()
    this.originData = null
    this.isUniquenessFieldChanged = false
  }

  onChangeDate(date){
    this.setState({startDate: date})
  }

  filter(model) {
    if(model && !model['aggregation_start_date']) {
      model['aggregation_start_date'] = null
    }

    model["credentials"] = model["credentials"].filter(item => {
      if(item && item.alphameric !== undefined && item.alphameric.trim() === '') {
        return false;
      }
      if(item && item.password !== undefined && item.password.trim() === '') {
        return false;
      }

      const originValue = this.originData['credentials'][item.service_form_type]
      // In case have no changed data
      if(!this.isUniquenessFieldChanged && lodash.isEqual(originValue, item)){
        return false;
      }

      return true;
    })

    return model
  }

  onSubmit(model) {
    // In case have uniqueness fields changed
    this.isUniquenessFieldChanged = this.checkUniquenessFieldChanged(model)
    if (this.isUniquenessFieldChanged && this.hasError())
      return

    const {id} = this.props.account
    model["credentials"] = Object.values(model["credentials"])
    model = this.filter(model)

    this.props.accountActions.accountUpdate(id, model).then(() => {
      this.props.accountActions.accountShow(id).then(() => this.props.toggle && this.props.toggle())
    })
  }

  specifyDate(e) {
    this.setState({hasSpecifyDate: "true" === e.target.value })
  }

  render_field(item, value) {
    let opts = {
      item: item,
      form: this.refs.form,
      className: "form-group col-md-12"
    }

    switch(item.input_type) {
      case "checkbox":
        opts['defaultValue'] = value
        return <CheckBox key={item.id} name={`credentials[${item.type}]`} type="checkbox" {...opts} />
      case "radio":
        opts['required'] = false
        opts['defaultValue'] = value ? value : {radio: item.format.radio[0]}
        return <Radio key={item.id} name={`credentials[${item.type}]`} {...opts} />
      case "table":
        opts['required'] = false
        return <Table name={`credentials[${item.type}]`} {...opts} />
      case "password":
        opts['required'] = false
        return <Input key={item.id} name={`credentials[${item.type}]`} type='password' {...opts} />
      default:
        opts['required'] = item.for_uniqueness
        opts['isHideRequiredLabel'] = true
        opts['defaultValue'] = value && value.alphameric
        return <Input key={item.id} name={`credentials[${item.type}]`} type='text' {...opts} />
    }
  }

  displayName() {
    const { display_name, service } = this.props.account

    return display_name || (service && service.name)
  }

  mergedCredentials() {
    const { service, credentials } = this.props.account
    let result = {}
    let itemCheckbox = null

    credentials && credentials.forEach((item) => {
      if(Object.keys(item).indexOf("checkbox") !== -1){
        itemCheckbox = service.forms.find(field => field.type === item.service_form_type).format

        Object.keys(item.checkbox).forEach((cbxKey) => {
          itemCheckbox.checkbox[cbxKey] = item.checkbox[cbxKey]
        })

        result[item.service_form_type] = itemCheckbox
      } else {
        let clonedItem = lodash.clone(item)
        delete clonedItem.text
        result[item.service_form_type] = clonedItem
      }
    })

    return result
  }

  isNotSavedOriginData() {
    if(!this.originData)
      return true

    const credentials = this.originData['credentials']
    const firstKey = Object.keys(credentials)[0]

    return credentials[firstKey] === undefined
  }

  saveOriginData() {
    const model = this.refs.form.getModel()
    this.originData = lodash.cloneDeep(model)
  }

  checkUniquenessFieldChanged(model) {
    const { forms } = this.props.account.service
    const uniquenessFields = []
    let isChanged = false

    forms.forEach((item) => {
      if(item.for_uniqueness)
        uniquenessFields.push(item.type)
    })

    uniquenessFields.forEach((field) => {
      if(!lodash.isEqual(this.originData['credentials'][field], model['credentials'][field])){
        isChanged = true;
      }
    })

    return isChanged
  }

  render() {
    const { service } = this.props.account
    const items = service.forms.filter(field => field.is_displayable)

    if(this.refs.form && this.isNotSavedOriginData()){
      this.saveOriginData()
    }

    return (
      <Modal isOpen={this.props.isOpen} className={`mfc-modal-normal bank-modal bank-edit-login ${this.state.hasSpecifyDate ? 'has-specify-date' : ''}`} centered={true}>
        <Formsy ref="form" onInvalidSubmit={this.showErrors} onSubmit={this.onSubmit} onValid={this.enableButton} onInvalid={this.disableButton}>
        <ModalHeader toggle={this.props.toggle}>{i18n.t('bank.edit_login', {name: this.displayName()})}</ModalHeader>
        <ModalBody>
          <div className="row no-gutters mfc-new-bank-desc">
            <div className="col-sm-12 info-service ">
              <p>金融機関登録前のご注意事項</p>
              <p className="small-desc">
                {parseHtml(service?.description)}
              </p>
              {service && service.login_url && <a target="_blank" href={service.login_url} rel="noopener noreferrer"><i
                className="fas fa-external-link-alt"></i> {`${service.name}のサイトでログインに用いる情報を確認する`}</a>}
            </div>
            <div className="w100">
              <div className="form-row">
                {items.map(item => this.render_field(item, this.accountCredential[item.type]))}
              </div>
              <div className="form-row checkbox-form">
                <label className=" ">{i18n.t('bank.get_data_date')}</label>
                <div className="form-group">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="is_specify_date" id="no_date" defaultChecked={!this.state.hasSpecifyDate} value={false} onChange={(e) => this.specifyDate(e)} />
                    <label className="form-check-label" htmlFor="no_date">
                      {i18n.t('bank.no_date')}
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="is_specify_date" id="specify_date" defaultChecked={this.state.hasSpecifyDate} value={true} onChange={(e) => this.specifyDate(e)}/>
                    <label className="form-check-label" htmlFor="specify_date">
                      {i18n.t('bank.after_specify_date')}
                    </label>
                  </div>
                </div>
              </div>

              {this.state.hasSpecifyDate && <div className="form-row">
                <label className="col-sm-12">{i18n.t('bank.md_newbank.body.select_date')}</label>
                <div className="col-sm-12 form-group mfc-box-calendar">
                  <DatePicker
                    name="aggregation_start_date"
                    required validations="minLength:10"
                    validationError="This value must is date"
                    startDate={this.state.startDate}
                    dateFormat={"yyyy/MM/dd"}/>
                </div>
              </div>}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
          <button className="btn mfc-btn-blue medium" type="submit">
            {i18n.t('common.save')}
          </button>
        </ModalFooter>
      </Formsy>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLogin)
